(function ($, window) {
    if (window.mg === undefined)
        window.mg = {};

    var _ = window.mg;

    _.queue = (function () {
        const _maxActive = 2;
        var items = [];

        var q = {
            activeItems: 0,
            addItem: function (item) {
                items.push(item);
                q.processNext();
            },
            insertItem: function (item, index) { // Insert an item at a given index (i.e., at the start of the queue)
                index = index || 0; // Default to index 0
                items.splice(index, 0, item); // Insert item at index, remove 0 items
                q.processNext();
            },
            processNext: function () {
                if (q.activeItems < _maxActive) {
                    var item = items.splice(0, 1)[0];

                    if (item) {
                        q.activeItems++;
                        if ($.isFunction(item.onBeforeProcess) && item.onBeforeProcess() === false) // Returning false in this method indicates that this item should not be processed further
                            q.processNext();

                        $.isFunction(item.onProcess) && item.onProcess(function () {
                            q.activeItems--;
                            q.processNext();
                        });
                    }
                }
            }
        };

        return q;
    })();
})(jQuery, window);